import React from 'react';
import { useTranslation } from 'react-i18next';

import styled from 'styled-components';
import { Campaign, CampaignTriggerType, CampaignType, TimingOptionEnum } from '@dev/ee-api/ee-api-models';
import { CampaignSuccessIcon, InfoIcon, Typography } from '@dev/ee-components';

import { Description } from './components/Description';
import { Buttons } from './components/Buttons';
import { IconInfoWrapper } from '../styled';

type StyledProps = {
    textLength: string;
};

const SuccessScreenWrapper = styled.div<StyledProps>`
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: ${({ textLength }): string => `${textLength}px`};
`;

const ImageWrapper = styled.div`
    svg {
        fill: #f3f5f8;
    }
    margin-bottom: 64px;
`;

const TimingOptionInfoWrapper = styled.div`
    display: flex;
    margin-top: 16px;
`;

export const SuccessScreen = (props: { campaign: Campaign }): JSX.Element => {
    const { t } = useTranslation();
    const { campaign } = props;
    const { Type, Name } = campaign;
    const isScheduled = campaign.TriggerOptions.Type === CampaignTriggerType.FutureScheduled;
    const isAutomated = CampaignType.Automated;
    const sendTime = isScheduled ? campaign.TriggerOptions.DateToSendOn : '';
    const isTimingOptions = campaign?.Options?.TimingOption !== TimingOptionEnum.None;
    const textLength = isTimingOptions ? (!isScheduled && !isAutomated ? '605' : '481') : '375';

    return (
        <SuccessScreenWrapper textLength={textLength}>
            <ImageWrapper>
                <CampaignSuccessIcon />
            </ImageWrapper>
            <Typography variant="h1">{t('success')}!</Typography>
            <Description
                campaignType={Type}
                isScheduled={isScheduled}
                sendTime={sendTime}
                isTimingOptions={isTimingOptions}
            />
            {isTimingOptions && (
                <TimingOptionInfoWrapper>
                    <IconInfoWrapper>
                        <InfoIcon />
                    </IconInfoWrapper>
                    <Typography variant="body1" bodyVariant="onPaper">
                        {isScheduled || isAutomated
                            ? t('sendtimeoptimization_success_scheduled')
                            : t('sendtimeoptimization_success_send')}
                    </Typography>
                </TimingOptionInfoWrapper>
            )}
            <Buttons campaignType={Type} campaignName={Name} isScheduled={isScheduled} />
        </SuccessScreenWrapper>
    );
};
